export const distanceOptions = [
  {
    title: '1 mile',
    value: 1,
  },
  {
    title: '2 miles',
    value: 2,
  },
  {
    title: '3 miles',
    value: 3,
  },
  {
    title: '4 miles',
    value: 4,
  },
  {
    title: '5 miles',
    value: 5,
  },
  {
    title: '10 miles',
    value: 10,
  },
  {
    title: '25 miles',
    value: 25,
  },
  {
    title: '50 miles',
    value: 50,
  },
];

export const frequencyOptions = [
  {
    title: 'All',
    value: 0,
  },
  {
    title: 'Occasional',
    value: 3,
  },
  {
    title: 'Full-time',
    value: 2,
  },
  {
    title: 'Part-time',
    value: 1,
  },
];

export const lookingOptions = [
  {
    title: 'Child care',
    value: 1,
  },
  {
    title: 'Sitters, nannies, & backup care',
    value: 8,
  },
  {
    title: 'Daycares & preschools',
    value: 7,
  },
  {
    title: 'Senior care',
    value: 3,
  },
  {
    title: 'Pet care',
    value: 2,
  },
  {
    title: 'Household services',
    value: 4,
  },
];
